import { Pipe, PipeTransform, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: 'trustHtml' })
export class TrustHtmlPipe implements PipeTransform {
    constructor(private _domSanitizer: DomSanitizer) { }

    public transform(value: string): any {
        if (value && value.toLowerCase().indexOf('<script') === -1)
            return this._domSanitizer.bypassSecurityTrustHtml(value);
        return this._domSanitizer.sanitize(SecurityContext.HTML, value);
    }
}